import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface RecalculateCellResponse {
  success?: boolean;
  execution_id?: string;
  target_execution_id?: string;
  cell_count?: number;
}

export const useRecalculateCell = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);

  return useMutation<
    RecalculateCellResponse,
    unknown,
    { tableId: string; sheetId: string; cellId: string }
  >({
    mutationFn: async ({ tableId, sheetId, cellId }) => {
      const response = await fetch(
        ENDPOINTS.smart_table_cell_recalculate(wid, tableId, sheetId, cellId),
        {
          method: "POST",
          headers: jsonAuthHeaders(userToken),
        },
      );
      return handleResponse(response);
    },
  });
};
